import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import { useAppSelector } from 'Store';
import { useRecuperarHoleritesQuery } from 'View/Service/Default/Holerites';

const Holerites = (): React.ReactElement => {
  const navegacao = useNavigate();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const { data: { holerites } = {} } = useRecuperarHoleritesQuery({
    options: { usuario_id: usuario?.id, assinado: 0 },
  });

  return (
    <React.Fragment>
      {holerites?.length ? (
        <div
          className="alert alert-danger cursor-pointer"
          onClick={() => navegacao('/holerites/historico')}
        >
          <strong className="me-3">
            <Icone nome="exclamation-circle-fill" /> Atenção
          </strong>
          Existem arquivos do <strong>holerite</strong> para você assinar!
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Holerites;
